// extracted by mini-css-extract-plugin
export default {"notFound__text":"NotFound_notFound__text__+RXe1"};